declare namespace $ {

	type $mol_select__value_shm_opencode_app_1 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['agent_provider_id'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__options_shm_opencode_app_2 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['agent_provider_options'] >
		,
		ReturnType< $mol_select['options'] >
	>
	type $mol_select__dictionary_shm_opencode_app_3 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['agent_provider_dict'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_string__hint_shm_opencode_app_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_opencode_app_5 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_opencode_app_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_opencode_app_7 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['Custom_provider_id'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_opencode_app_8 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_opencode_app_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_opencode_app_10 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['Custom_provider_name'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__hint_shm_opencode_app_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_opencode_app_12 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_base_url'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_opencode_app_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_opencode_app_14 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['Custom_provider_base_url'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_password__value_shm_opencode_app_15 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_api_key'] >
		,
		ReturnType< $mol_password['value'] >
	>
	type $mol_labeler__title_shm_opencode_app_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_opencode_app_17 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['Custom_provider_api_key'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__hint_shm_opencode_app_18 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_opencode_app_19 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_model_id'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_opencode_app_20 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_opencode_app_21 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['Custom_provider_model_id'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__value_shm_opencode_app_22 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_model_name'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_opencode_app_23 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_opencode_app_24 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['Custom_provider_model_name'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_button_major__title_shm_opencode_app_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_opencode_app_26 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_add'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_list__rows_shm_opencode_app_27 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_labeler__title_shm_opencode_app_28 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_opencode_app_29 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['Provider'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_expander__title_shm_opencode_app_30 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_expander['title'] >
	>
	type $mol_expander__expanded_shm_opencode_app_31 = $mol_type_enforce<
		ReturnType< $shm_opencode_app['custom_provider_expanded'] >
		,
		ReturnType< $mol_expander['expanded'] >
	>
	type $mol_expander__content_shm_opencode_app_32 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_expander['content'] >
	>
	export class $shm_opencode_app extends $shm_agent_app {
		agent_provider_id( next?: string ): string
		agent_provider_options( ): readonly(any)[]
		agent_provider_dict( ): Record<string, any>
		Provider( ): $mol_select
		custom_provider_expanded( next?: boolean ): boolean
		custom_provider_id( next?: string ): string
		Custom_provider_id( ): $mol_string
		Custom_provider_id_label( ): $mol_labeler
		custom_provider_name( next?: string ): string
		Custom_provider_name( ): $mol_string
		Custom_provider_name_label( ): $mol_labeler
		custom_provider_base_url( next?: string ): string
		Custom_provider_base_url( ): $mol_string
		Custom_provider_base_url_label( ): $mol_labeler
		custom_provider_api_key( next?: string ): string
		Custom_provider_api_key( ): $mol_password
		Custom_provider_api_key_label( ): $mol_labeler
		custom_provider_model_id( next?: string ): string
		Custom_provider_model_id( ): $mol_string
		Custom_provider_model_id_label( ): $mol_labeler
		custom_provider_model_name( next?: string ): string
		Custom_provider_model_name( ): $mol_string
		Custom_provider_model_name_label( ): $mol_labeler
		custom_provider_add( next?: any ): any
		Custom_provider_add( ): $mol_button_major
		Custom_provider_content( ): $mol_list
		Provider_label( ): $mol_labeler
		Custom_provider( ): $mol_expander
	}
	
}

//# sourceMappingURL=app.view.tree.d.ts.map